import { render, staticRenderFns } from "./FeaturedTextTwo.vue?vue&type=template&id=58d85b40&"
import script from "./FeaturedTextTwo.vue?vue&type=script&lang=js&"
export * from "./FeaturedTextTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports